import React from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "../../../Header/Header";
import img from "./img/formImg.webp";
import BoltIcon from "@mui/icons-material/Bolt"; // For ⚡ icon
import CompanySection from "./CompanySection";
import WhatsAppForm1 from "./WhatsAppForm1";
import UseCaseSection from "./UseCaseSection";
import WhatsAppFormUseCase from "./WhatsAppFormUseCase";
import CompanyCards from "./CompanyCards";
import CardMenuSection from "./CardMenuSection ";
import WhatsBusinessAPI from "./WhatsBusinessAPI";
import FooterSection from "../FooterSection";

const WhatsAppForm = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Header />

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundImage: `url('bg2.svg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{
            p: { xs: 3, md: 10 },
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
          }}
        >
          <Grid
            container
            spacing={6}
            alignItems="center"
            justifyContent="space-between"
          >
            {/* Left Content */}
            <Grid item xs={12} md={6}>
              <Box sx={{ pl: { xs: 0, sm: 2, md: 4 } }}>
                <Typography
                  variant={isMobile ? "h4" : "h3"}
                  component="h1"
                  fontWeight="bold"
                  gutterBottom
                >
                  Collect data
                  <br />
                  seamlessly with
                  <br />
                  <Box component="span" color="#00D084">
                    WhatsApp Forms
                  </Box>
                </Typography>

                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{
                    mt: 3,
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    maxWidth: 520,
                    lineHeight: 1.8,
                  }}
                >
                  Enhance user engagement with forms that open directly within
                  WhatsApp— eliminating the need for external browsers. Capture
                  leads, qualify users, book orders and more using WhatsApp
                  forms
                </Typography>

                <Box
                  sx={{
                    mt: 4,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    color: "text.secondary",
                  }}
                >
                  <BoltIcon sx={{ color: "#FFC107" }} />
                  <Typography component="span">
                    Powered by{" "}
                    <Box component="span" fontWeight="bold">
                      Official WhatsApp Business API
                    </Box>
                  </Typography>
                </Box>

                <Box
                  sx={{
                    mt: 4,
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "#00D084",
                      color: "#fff",
                      fontWeight: "bold",
                      px: 4,
                      py: 1.5,
                      "&:hover": { bgcolor: "#00b96e" },
                    }}
                  >
                    Start for FREE →
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{
                      fontWeight: "bold",
                      borderColor: "#00D084",
                      color: "#000",
                      px: 4,
                      py: 1.5,
                    }}
                  >
                    Talk to Sales
                  </Button>
                </Box>
              </Box>
            </Grid>

            {/* Right Image */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  textAlign: "center",
                  pr: { xs: 0, sm: 2, md: 4 },
                }}
              >
                <img
                  src={img}
                  alt="WhatsApp Form"
                  style={{
                    width: "100%",
                    maxWidth: "580px",
                    height: "auto",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <CompanySection />
      <WhatsAppForm1 />
      <UseCaseSection />
      <WhatsAppFormUseCase />
      <CompanyCards />
      <CardMenuSection />
      <WhatsBusinessAPI />
      <FooterSection />
    </>
  );
};

export default WhatsAppForm;
